import { render, staticRenderFns } from "./Cart-Minus.vue?vue&type=template&id=2f7cc00b&lang=pug&"
import script from "./Cart-Minus.vue?vue&type=script&lang=js&"
export * from "./Cart-Minus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports